import { Cartao } from '../../componentes/Cartao.js';
import { IconeConfere } from '../../componentes/Icones.js';
import { Tabela } from '../../componentes/Tabela.js';
import type { Coluna } from '../../componentes/Tabela.js';
import { LINHAS_DA_MATRIZ, PERFIS } from '../../autorizacao/permissoes.js';
import type { LinhaDaMatriz } from '../../autorizacao/permissoes.js';
import './MatrizDePermissoes.css';

/**
 * A matriz de perfis do RF-078, visível na própria tela (UC13, passo 4).
 *
 * Ela lê `LINHAS_DA_MATRIZ` — a MESMA fonte que decide se um botão existe.
 * Uma tabela desenhada à parte viraria documentação desatualizada no dia em
 * que a regra mudasse, e o administrador estaria concedendo uma coisa lendo
 * outra.
 *
 * Nenhuma célula significa por cor: cada uma carrega o texto "Permitido" ou
 * "Não permitido" para o leitor de tela (RNF-022).
 */
function Marca({ permitido }: { readonly permitido: boolean }) {
  return permitido ? (
    <span className="matriz__sim">
      <IconeConfere tamanho={15} />
      <span className="apenas-leitor-de-tela">Permitido</span>
    </span>
  ) : (
    <span className="matriz__nao">
      <span aria-hidden="true">—</span>
      <span className="apenas-leitor-de-tela">Não permitido</span>
    </span>
  );
}

const COLUNAS: readonly Coluna<LinhaDaMatriz>[] = [
  { chave: 'acao', rotulo: 'Pode', celula: (linha) => linha.rotulo },
  ...PERFIS.map((perfil) => ({
    chave: perfil,
    rotulo: perfil,
    largura: '17%',
    celula: (linha: LinhaDaMatriz) => <Marca permitido={linha.perfis.includes(perfil)} />,
  })),
];

export function MatrizDePermissoes() {
  return (
    <Cartao titulo="Permissões por perfil" acessorio="RF-078" semRespiro>
      <Tabela
        itens={LINHAS_DA_MATRIZ}
        colunas={COLUNAS}
        chaveDe={(linha) => linha.acao}
        descricao="Permissões por perfil"
        densidade="confortavel"
      />
    </Cartao>
  );
}
